module.exports = __webpack_public_path__ + "img/P150T_weapon_124.c8c24651.png";